var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaojiao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.13729 14.9323C2.13821 13.5221 2.14661 12.7906 2.22254 12.1709C2.86492 6.92825 6.99591 2.79726 12.2386 2.15489C12.8582 2.07896 13.5898 2.07055 15 2.06963V14.9323H2.13729Z",
    fill: "#95E3FB",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7635 0.567688V0.567688C5.54286 0.567688 0.5 5.61055 0.5 11.8312V11.8312",
    stroke: "#00C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaojiao);
export default __webpack_public_path__ + "static/media/daojiao.9ef0a0da3edf8df3f85ce91e799af3d8.svg";
export { ForwardRef as ReactComponent };